export const SitePermissions = {
  ['access__settings']: 0n,
  ['access__retail']: 1n,
  ['access__clients']: 2n,
  ['access__dashboards__display_home_revenue_and_retail_snapshot']: 3n,
  ['access__dashboards__display_home_snapshot']: 4n,
  ['access__notifications__receive_sms_running_low']: 5n,
  ['access__reports']: 7n,
  ['schedule__team_view_access']: 8n,
  ['schedule__booking_for_all_team_members']: 9n,
  ['schedule__booking_requests']: 10n,
  ['schedule__allow_as_instructor_for_schedule']: 11n,
  ['schedule__sessions__add_and_edit']: 12n,
  ['schedule__sessions__cancel']: 13n,
  ['schedule__allow_custom_session_creation']: 14n,
  ['schedule__edit_of_employee_work_hours']: 15n,
  ['schedule__add_or_remove_booked_clients']: 16n,
  ['schedule__communicate_with_clients_within_schedule']: 17n,
  ['schedule__enable_late_cancel_and_refund']: 18n,
  ['schedule__soap_notes__read']: 20n,
  ['schedule__soap_notes__write']: 21n,
  ['schedule__allow_bookings_for_team_outside_of_employee_work_hours']: 22n,
  ['schedule__enable_sub_instructor']: 23n,
  ['schedule__enable_sub_instructor_edit_instructor']: 24n,
  ['payments__request_payment_access']: 25n,
  ['payments__process_payments_within_schedule']: 26n,
  ['payments__payroll_report_access']: 27n,
  ['payments__access_to_cash_draw']: 28n,
  ['schedule__bulk_cancel_sessions']: 30n,
  ['payments__change_client_payment_method']: 31n,
  ['payments__send_payment_request_email']: 32n,
  ['payments__retry_failed_payment_with_payment_method']: 33n,
  ['payments__edit_dishonor_fee']: 34n,
  ['payments__service_cancellation']: 35n,
  ['payments__advanced_checkout']: 36n,
  ['payments__advanced_checkout__credit_activation_date']: 37n,
  ['payments__advanced_checkout__first_payment_date']: 38n,
  ['payments__advanced_checkout__credit_valid_until']: 39n,
  ['payments__advanced_checkout__auto_renew']: 40n,
  ['payments__advanced_checkout__one_time_setup_fee']: 41n,
  ['payments__advanced_checkout__discount_any_price']: 42n,
  ['payments__advanced_checkout__discount_only_lower_price']: 43n,
  ['payments__bulk_edit_transactions']: 44n,
  ['settings__retail']: 45n,
  ['settings__retail__packages__read']: 46n,
  ['settings__retail__packages__write']: 47n,
  ['settings__retail__packages__write_restricted']: 48n,
  ['settings__retail__packages__archive']: 49n,
  ['settings__retail__memberships__read']: 50n,
  ['settings__retail__memberships__write']: 51n,
  ['settings__retail__memberships__write_restricted']: 52n,
  ['settings__retail__memberships__archive']: 53n,
  ['settings__retail__products__read']: 54n,
  ['settings__retail__products__write_add']: 55n,
  ['settings__retail__products__write_edit']: 56n,
  ['settings__retail__promo_codes']: 57n,
  ['settings__retail__gift_cards__read']: 58n,
  ['settings__retail__gift_cards__write']: 59n,
  ['settings__retail__fees']: 60n,
  ['settings__retail__sale_settings']: 61n,
  ['settings__retail__general_settings']: 62n,
  ['settings__retail__terminals']: 63n,
  ['settings__account']: 64n,
  ['settings__account__billing']: 65n,
  ['settings__account__tax']: 66n,
  ['settings__account__invoice']: 67n,
  ['settings__account__point_of_sale']: 68n,
  ['settings__account__payroll']: 69n,
  ['settings__location']: 70n,
  ['settings__location__configurations']: 71n,
  ['settings__location__integrations']: 72n,
  ['settings__location__operations']: 74n,
  ['settings__location__checkin']: 75n,
  ['settings__location__communication']: 76n,
  ['settings__location__social_media']: 77n,
  ['settings__scheduler']: 78n,
  ['settings__scheduler__rules']: 79n,
  ['settings__scheduler__session_types']: 80n,
  ['settings__scheduler__session_templates']: 81n,
  ['settings__scheduler__calendar_configurations']: 82n,
  ['clients__client_password_reset']: 83n,
  ['clients__client_merge']: 84n,
  ['clients__delete']: 89n,
  ['clients__bulk_edit_packages_expiry_date']: 90n,
  ['reports__edit_restricted_reports']: 91n,
  ['reports__client_and_attendance']: 92n,
  ['reports__financial']: 94n,
  ['reports__staff']: 95n,
  ['reports__inventory']: 96n,
  ['settings__account__sms_credits']: 112n,
  ['reports__download']: 113n,
  ['site_pii__view_contact_details']: 114n,
  ['site_pii__view_full_identity']: 115n,
  ['site_pii__export_pii']: 116n,
  ['content__create']: 117n,
  ['content__edit_own']: 118n,
  ['content__publish_own']: 119n,
  ['content__delete_own']: 120n,
  ['content__view_corporate']: 121n,
  ['wellness__equipments__manage']: 122n,
  ['settings__location__website_widgets']: 123n,
  ['payments__service_plan_change']: 124n,
  ['import__initiate']: 129n,
  ['import__preview']: 130n,
  ['import__approve_and_execute']: 131n,
  ['import__delete']: 132n,
  ['import__download_source']: 133n,
  ['import__download_audit']: 134n,
  // CORE-1322 / INT-67: per-site accounting-code library (gateway-neutral keys; DD-011).
  // Values are unique bit indices in the permission bitmask — appended after the current max (134n);
  // the 97–111n / 125–128n gaps are intentionally NOT reused (retired bits).
  ['settings__retail__account_codes__read']: 135n,
  ['settings__retail__account_codes__write']: 136n,
  // Site-scoped audit-history read (site settings → Audit History tile).
  ['audit__read']: 137n,
  // OC-320 product tiering, location level — Settings > Account, where the spec adds an "Add-ons"
  // menu item. RESERVED, not yet enforced; see the corporate-permissions note.
  //   manage_plan     — change this location's product tier, when the brand has allowed override
  //   manage_add_ons  — enable/disable add-on themes for this location, when the brand has allowed
  //                     override. NOTE this has no data model yet: CorporateThemeSubscription is
  //                     keyed (corporateId, themeId) with no site equivalent, so Phase 3 must add
  //                     site-level add-on state before this bit can gate anything real.
  //
  // Namespaced under settings__account__ beside settings__account__sms_credits (112n); every key
  // in THIS file is namespaced, while the corporate file keeps bare verb_noun keys.
  // Appended after the current max (137n); the 97–111n / 125–128n retired gaps are not reused.
  // No backfill: a new bit is 0 for everyone until Phase 2 grants it, and when it does it should
  // follow MarketplacePermissionService — accept this bit OR an existing broad admin grant.
  ['settings__account__manage_plan']: 138n,
  ['settings__account__manage_add_ons']: 139n,
  // OC-898 — sees the Capital nav item and the Capital financing page. Deliberately its own
  // permission rather than folding into access__retail: financing terms and repayment history are
  // more sensitive than day-to-day retail, so a brand can grant retail without granting Capital.
  // Renumbered from 138n on merge: OC-320 shipped that bit first and a shipped bit is immovable,
  // because every stored bitmap would otherwise decode this position as a different permission.
  ['access__capital']: 140n,
  // OC-772: Retail Settings → Add-Ons management. Read/write only — no
  // write_restricted/archive split (archive gates on __write). Appended after
  // the current max; never renumber or fill retired-bit gaps.
  // Renumbered from 138n/139n on merge: OC-320 shipped 138n/139n and OC-898
  // shipped 140n first, and a shipped bit is immovable, so these unshipped bits
  // moved to the new tail instead.
  ['settings__retail__add_ons__read']: 141n,
  ['settings__retail__add_ons__write']: 142n,
  // OC-167: its own bit rather than folding into one_time_setup_fee — collecting a
  // pre-sale membership's first period at sign-up, before the member has any access,
  // is a larger discretion than adjusting a fee.
  ['payments__advanced_checkout__pay_up_front']: 143n,
  // OC-1322: creating, editing, deleting and reordering the site's shared Schedule filter views,
  // plus setting the site default. Its own bit rather than folding into
  // schedule__sessions__add_and_edit, which would hand every session editor control of what the
  // whole site sees on opening Schedule. Backfilled onto existing policies with schedule access,
  // so nothing changes on ship. Appended after the current max; retired gaps 97–111n / 125–128n
  // stay unused.
  ['schedule__manage_site_views']: 144n,
  // OC-1390: staff "Update Credits" on sold packages and memberships (ServicesService.adjustCredits). Its
  // own bit rather than riding on access__clients: adding or removing credits changes what a
  // member is entitled to, which is a larger discretion than opening a client profile. Backfilled
  // onto every policy holding access__clients, so nothing changes on ship.
  ['payments__service_credit_adjustment']: 145n,
  // OC-1481: marking and correcting booking attendance (Attended / No Show / Late Cancelled, and
  // rejoining a late cancelled booking). Its own bit rather than riding on
  // schedule__sessions__add_and_edit, which also grants creating, editing and cancelling bookings,
  // more than an instructor should hold. Backfilled onto every policy holding
  // schedule__sessions__add_and_edit or schedule__allow_as_instructor_for_schedule.
  ['schedule__mark_attendance']: 146n,
  // MEM-27: deleting sessions (removing them from the schedule, the Cancelled sessions list and the
  // member app) is a bigger step than cancelling, so it gets its own bit instead of riding on
  // schedule__sessions__cancel. Backfilled onto every policy holding schedule__sessions__cancel, so
  // nobody who could delete before loses it on ship.
  ['schedule__sessions__delete']: 147n,
  // OC-1698: tracking tanning lamp hours and logging lamp changes. Its own bit rather than riding
  // on wellness__equipments__manage, which also edits bed details and timer limits: brands lock
  // that to support staff while every location still has to reset its own lamp counters.
  // Backfilled onto every policy holding wellness__equipments__manage, so nothing changes on ship.
  ['wellness__equipment_lamps__manage']: 148n,
  // OC-1461: accept or decline members qualified to move INTO this site under rolling APPROVAL mode.
  // Site-scoped rather than riding on the corporate member_movement__approve, because the whole point
  // of the posture is that a location controls its own intake without seeing the rest of the brand.
  // Took 146 on this branch; renumbered to 149 on the main merge, which had shipped 146-148.
  ['member_movement__approve_incoming']: 149n,
  // Native class covers (docs/native-class-covers/PRD.md §3). Request and claim are backfilled onto
  // instructor policies (holders of schedule__allow_as_instructor_for_schedule), the rest onto
  // policies that can edit the schedule (schedule__sessions__add_and_edit); both plus full access.
  ['schedule__covers__request']: 150n,
  ['schedule__covers__claim']: 151n,
  ['schedule__covers__approve']: 152n,
  ['schedule__covers__manage_qualifications']: 153n,
  ['settings__covers']: 154n,
  // OC-1795: choosing a Test Time other than the bed's Minimum Time. Its own bit so a brand can let
  // maintenance staff run full test sessions without letting them edit equipment settings.
  // Backfilled onto every policy holding wellness__equipments__manage, so managers keep it on ship.
  ['wellness__equipment_test_time__override']: 155n,
  // OC-1573: its own bit rather than riding on access__retail, so a brand can keep front-desk roles
  // selling and booking while taking away the discretion to give money back. Backfilled onto every
  // policy that could refund before (access__retail, payments__service_plan_change), so nothing
  // changes on ship. Enforced only while FeatureFlagKeys.RefundPermissionEnabled is on.
  // Took 150n, then 155n, on its branch; renumbered on main merges that had shipped 150-155n.
  ['payments__refund']: 156n,
  // OC-148: reinstating a staff-cancelled invoice puts a charge back on a member's schedule, so it
  // gets its own bit rather than riding on access__retail (which cancel keeps using). Product asked
  // for it off by default: the backfill grants it to All Access / full-access policies only.
  ['payments__invoice_reinstate']: 158n,
  // OC-1858: lets staff cancel a membership before its cancellation notice period has run, or
  // immediately. Its own bit so a brand can let front-desk roles cancel without letting them skip
  // the notice the member agreed to. Backfilled onto full-access policies only.
  // Took 158n on its branch; renumbered on the main merge that had shipped 158n.
  ['payments__service_cancellation_notice_override']: 159n,
  // OC-1721 sales commissions. Location-scoped keys; the brand-wide keys live in corporate-permissions
  // with distinct names because hasPermission resolves the corporate list first.
  // Took 149-152n, 157-160n, then 158-161n, on its branch; renumbered on main merges that had shipped 149-159n.
  ['settings__account__commissions']: 160n,
  ['reports__commissions']: 161n,
  ['commissions__adjust']: 162n,
  ['commissions__attribution__edit']: 163n,
  // MEM-989: posting and ending location alerts (Location configuration row 1.17). Its own bit
  // because emergencies are handled by whoever is on shift, so front-desk and duty managers need
  // alerts without the rest of Location configuration. Backfilled onto every policy holding
  // settings__location__configurations, so nobody who manages the tab loses alerts on ship.
  // Took 160n on its branch; renumbered on the main merge that had shipped 160-165n (OC-1721).
  ['settings__location__member_alerts']: 166n,
  // INT-1224: lets a front desk start a UV session for a client whose skin-type assessment is
  // missing or due, where the location requires one. Planned as 158n, 159n, 160n and then 166n, all of
  // which main had shipped by the time this branch merged it. Backfilled onto wellness__equipments__manage
  // holders.
  ['wellness__equipment_skin_type__override']: 167n,
  // INT-1224: lets a manager record a skin type assessed outside Hapana (a migration or a paper
  // assessment) as the client's current result. Its own bit, separate from the override, because
  // recording a result changes what every later UV start sees. Backfilled onto
  // wellness__equipments__manage holders.
  ['wellness__equipment_skin_type__assign']: 168n,
  // OC-1986: lets a front desk check in, book or start a tan for a client who owes at a location
  // of a brand that blocks on debt anywhere. Every use is audited. Backfilled onto the full-access tier.
  ['clients__owed_balance_block__override']: 169n,
  // OC-1991: lets staff sell a package or membership in Core to a client who has not bought one of
  // the plans on its New Sale Dynamic Display list. Every use is audited. Backfilled onto the
  // full-access tier.
  ['retail__sales__sell_outside_dynamic_display']: 170n,
  // OC-1992: lets staff sell a package or membership in Core outside its sale availability
  // dates. Every use is audited. Backfilled onto the full-access tier.
  ['retail__sales__sell_outside_availability']: 171n,
  // OC-1933 equipment policy compliance (D-12). Backfilled onto the full-access tier only.
  ['wellness__equipment_eligibility__view']: 172n,
  ['clients__policy_forms__record_paper']: 173n,
  ['clients__policy_forms__approve_paper']: 174n,
  ['clients__policy_forms__view_evidence']: 175n,
  ['clients__policy_forms__void']: 176n,
  ['settings__location__policy_gating']: 177n,
  ['settings__location__policy_import']: 178n,
  ['settings__location__policy_import_trusted']: 179n,
  ['reports__policy_evidence_export']: 180n,
  // OC-2075: choose the membership a member moves onto, re-initiate failed moves, and change this
  // location's incoming approval and notifiers. Separate from 149 so accept/decline can be granted
  // without the right to change the posture. Backfilled onto member_movement__approve_incoming holders.
  ['member_movement__manage_incoming']: 181n,
} as const

export type SitePermissionsKey = keyof typeof SitePermissions

export type ReservedPermissionBit = {
  bit: bigint
  key: string
  ticket: string
  reason: string
}

// A retired bit number is never reused: a policy array or a computedPermissions bitmap written
// before the retirement, or imported after the strip migration ran, can still carry it, so a new
// key at the same number would be granted to everyone who held the old one. Nobody can hold a
// retired bit and nothing reads it, so the users service's assignability checks ignore one left in
// a stored policy (RETIRED_SITE_PERMISSIONS), and computedPermissions never carries it because the
// recompute drops numbers this enum lacks. Retiring a bit still ships with a migration that strips
// it: see stripPermissions in database/permission-backfill.ts. The retirement itself is
// recorded in RETIRED_PERMISSION_BITS in __tests__/permission-bit-ledger.ts, and this list must
// match its site entries.
export const RESERVED_SITE_PERMISSION_BITS: readonly ReservedPermissionBit[] = [
  {
    bit: 6n,
    key: 'access__notifications__receive_account_delete_and_refund_failed_email',
    ticket: 'OC-1222',
    reason: 'Nothing reads it.',
  },
  {
    bit: 19n,
    key: 'schedule__class_rating',
    ticket: 'OC-1222',
    reason: 'Nothing reads it.',
  },
  {
    bit: 29n,
    key: 'schedule__enable_checkin_popups',
    ticket: 'OC-1222',
    reason: 'Check-in popups are always on, and OC-1226 moved attendance off this bit.',
  },
  {
    bit: 73n,
    key: 'settings__location__tools',
    ticket: 'OC-1222',
    reason: 'The Location Tools tab does not exist in V2.',
  },
  {
    bit: 85n,
    key: 'clients__programs',
    ticket: 'OC-1222',
    reason: 'No programs in V2.',
  },
  {
    bit: 86n,
    key: 'clients__leads',
    ticket: 'OC-1222',
    reason: 'No leads in V2.',
  },
  {
    bit: 87n,
    key: 'clients__feedback',
    ticket: 'OC-1222',
    reason: 'Nothing reads it.',
  },
  {
    bit: 88n,
    key: 'clients__groups',
    ticket: 'OC-1222',
    reason: 'Everyone manages client groups in V2.',
  },
  {
    bit: 93n,
    key: 'reports__marketing',
    ticket: 'OC-1222',
    reason: 'Marketing reports do not exist in V2.',
  },
]
